module.exports = __webpack_public_path__ + "static/media/playlistActive.36dd4a93.svg";